const serviceUrl = 'http://zipcloud.ibsnet.co.jp/api/search?zipcode='

export default class PostcodeService {
  static async searchPostcode(postcode) {
    const url = serviceUrl + postcode.toString()

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    })

    if (response.ok) {
      const data = await response.json()
      return data.results
    } else {
      throw new Error(`${response.status} ${response.message}`)
    }
  }

  static isValidPostcode(inputString) {
    const regex = /^\d{7}$/
    return regex.test(inputString)
  }
}
